export default "__VITE_ASSET__DYmEaLfj__"